var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 54,
    height: 54,
    rx: 27,
    stroke: "#FB7C2F",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_516_112",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12.5,
    width: 31,
    height: 31,
    fill: "#D9D9D9",
    stroke: "#FB7C2F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_516_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3458 28.0125H26C27.1808 28.0125 28.2004 27.6281 29.0583 26.8593C29.916 26.0907 30.4341 25.1381 30.6123 24.0019L30.6146 23.9875H30.6H20.0125V21.3458H30.2H30.22L30.2112 21.3279C29.8325 20.548 29.2698 19.9075 28.5236 19.4063C27.777 18.9048 26.9357 18.6542 26 18.6542H20.0125V16.0125H35.9875V18.6542H31.6667H31.6402L31.657 18.6746C31.9676 19.0518 32.245 19.4622 32.489 19.906C32.733 20.3495 32.9215 20.8263 33.0546 21.3365L33.057 21.3458H33.0667H35.9875V23.9875H33.3H33.2886L33.2876 23.9988C33.1101 25.8847 32.3337 27.4652 30.9582 28.7408C29.5828 30.0164 27.9303 30.6542 26 30.6542H25.0333H25.004L25.0243 30.6753L33.9707 39.9875H30.3053L21.3458 30.6616V28.0125Z",
    fill: "#FB7C2F",
    stroke: "#FB7C2F",
    strokeWidth: 0.025
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.8e031adfa042add6a813196bf4ec756c.svg";
export { ForwardRef as ReactComponent };